import { render, staticRenderFns } from "./NotificationItemComment.vue?vue&type=template&id=7b9ea9fc"
import script from "./NotificationItemComment.vue?vue&type=script&lang=js"
export * from "./NotificationItemComment.vue?vue&type=script&lang=js"
import style0 from "./NotificationItemComment.vue?vue&type=style&index=0&id=7b9ea9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports